<template>
  <div class="contents wrap" id="skipToContents">
    <div class="learn-tit">
      <cite>과정명</cite>
      <strong>{{ resultMap.subjNm }}</strong>
    </div>
    <div class="learn-date" v-if="!isMobile()">
      <dl>
        <dt>
          <i class="ico-time"></i>
          학습종료까지 남은시간
        </dt>
        <dd>
          <em class="red">
            <countdown ref="learnCountdown" :time="resultMap.learnRemainSec * 1000">
              <template slot-scope="props">{{ props.days }}일 {{ props.hours }}시 {{ props.minutes }}분 {{ props.seconds }}초</template>
            </countdown>
          </em>
        </dd>
      </dl>
      <dl>
        <dt>&nbsp;&nbsp; 학습기간</dt>
        <dd>
          <b>{{ resultMap.learnStartDt | dateTimeShortFormat }} ~ {{ resultMap.learnEndDt | dateTimeShortFormat }}</b>
        </dd>
      </dl>
    </div>

    <ul class="learn-nav">
      <li :class="$route.path.indexOf('main') > -1 ? 'current' : ''">
        <a @click="goMenu('MAIN')">
          <i class="home"></i>
          홈
        </a>
      </li>
      <li :class="$route.path.indexOf('lesson') > -1 ? 'current' : ''"><a @click="goMenu('LESSON')">학습목차</a></li>
      <li :class="$route.path.indexOf('10013') > -1 ? 'current' : ''"><a @click="goMenu('NOTICE')" title="공지사항">공지사항</a></li>
      <li v-for="item in resultEfList" :key="item.efCd">
        <a @click="goMenu(item)" :class="getMenuClass(item)" :title="item.efNm">{{ item.efNm }}</a>
      </li>
    </ul>

    <slot />
  </div>
</template>

<script>
import Vue from "vue";
import { apiURL } from "@/utils";
import VueCountdown from "@chenfengyuan/vue-countdown";
Vue.component(VueCountdown.name, VueCountdown);

export default {
  name: "LearnLayout",
  components: {},
  data: function () {
    return {
      enrollNo: this.$route.params.enrollNo,
      resultEfList: [],
      resultMap: {
        learnRemainSec: 0,
      },
    };
  },
  created() {
    // 메뉴 번호 강제 설정.
    this.$store.dispatch("setCurrentMenu", "225");
    this.getLearnInfo();
  },
  methods: {
    getLearnInfo() {
      this.request(`${apiURL}/learn/info/${this.enrollNo}`).then(({ data }) => {
        this.resultMap = data.resultMap;
        this.resultEfList = data.resultEfList;
      });
    },
    goMenu(menu) {
      const efCd = typeof menu === "string" ? menu : menu.efCd;
      console.log(efCd);
      if (!efCd || efCd == "MAIN") this.$router.push(`/learn/main/${this.enrollNo}`);
      if (!efCd || efCd == "LESSON") this.$router.push(`/learn/lesson/${this.enrollNo}`);
      if (!efCd || efCd == "NOTICE") this.$router.push(`/learn/bbs/${this.enrollNo}/10013`);
      if (!efCd || efCd == "QNA") this.$router.push(`/learn/bbs/${this.enrollNo}/10015`);
      if (!efCd || efCd == "DTA") this.$router.push(`/learn/bbs/${this.enrollNo}/10014`);
      if (!efCd || efCd == "MEX") this.$router.push(`/learn/exam/list/${this.enrollNo}`);
      if (!efCd || efCd == "FEX") this.$router.push(`/learn/exam/list/${this.enrollNo}`);
      if (!efCd || efCd == "PRJ") this.$router.push(`/learn/project/list/${this.enrollNo}`);
      if (!efCd || efCd == "SRV") this.$router.push(`/learn/survey/list/${this.enrollNo}`);
      if (!efCd || efCd == "GLO") this.$router.push(`/learn/survey/list/${this.enrollNo}`);
    },
    getMenuClass(item) {
      if (this.$route.path.includes("exam") && item.efCd == "FEX") return "current";
      if (this.$route.path.includes("project") && item.efCd == "PRJ") return "current";
      if (this.$route.path.includes("survey") && item.efCd == "SURVEY") return "current";
      return "";
    },
  },
};
</script>
